




































































import { State, Action, Getter } from 'vuex-class';
import { Component, Vue, Watch } from 'vue-property-decorator';

@Component({
  components: {
    PagePresetDashboard: () => import('@/layouts/presets/dashboard.vue'),
    PartBox: () => import('@/layouts/parts/box.vue'),
    PartOverlay: () => import('@/layouts/parts/overlay.vue'),
    // Form elements
    FormBase: () => import('@/components/forms/Base.vue'),
    FormInput: () => import('@/components/forms/Input.vue'),
    FormButton: () => import('@/components/forms/Button.vue'),
    ServerError: () => import('@/components/forms/ServerError.vue'),
    LanguageSelector: () => import('@/components/parts/LanguageSelector.vue'),
  },
})
export default class PageTransportCostsShow extends Vue {
  i18n: string = 'views.transport-costs.show';

  @Getter('transport-costs/viewing') transportCost?: TransportCost;

  @Getter('workspace/selected') workspace!: Workspace;

  @Action('transport-costs/create') createTransportCost!: ({ data, workspaceId }: { data: TransportCostCreateData; workspaceId: number }) => Promise<TransportCost>;

  @Action('transport-costs/update') updateTransportCost!: ({ id, data, workspaceId }: { id: number; data: TransportCostUpdateData; workspaceId: number }) => Promise<TransportCost>;

  @Action('transport-costs/delete') deleteTransportCost!: (payload: { id: number; workspaceId: number }) => Promise<TransportCost>;

  $refs!: Vue['$refs'] & {
    transportCostForm: FormClass;
    deleteForm: FormClass;
  };

  formLoaded: boolean = false;

  payload: TransportCostCreateData = {
    price: 0,
    type: 'REGULAR_TRANSPORT',
  };

  popupDeleteTransportCost: boolean = false;

  get transportCostTypes() {
    return ['SPECIAL_TRANSPORT', 'REGULAR_TRANSPORT'];
  }

  handleSubmit() {
    let func: string = 'updateTransportCost';
    if (!this.transportCost?.id) {
      func = 'createTransportCost';
    }

    // @ts-ignore
    this[func]({ id: this.transportCost?.id, data: this.payload, workspaceId: this.workspace.id })
      .then((transportCost: TransportCost) => {
        this.$refs.transportCostForm.handleSuccess();
        if (func === 'createTransportCost' && this.transportCost!.id) {
          this.$router.push({ name: 'transport-costs-detail', params: { id: `${this.transportCost!.id}` } });
        }
      })
      .catch((e: ErrorResponse) => this.$refs.transportCostForm.handleErrors(e));
  }

  handleDelete() {
    if (this.transportCost?.id) {
      this.deleteTransportCost({ id: this.transportCost.id, workspaceId: this.workspace.id })
        .then(() => {
          this.popupDeleteTransportCost = false;
          this.$refs.deleteForm.handleSuccess();
          this.$router.push({ name: 'transport-costs' });
        })
        .catch((e: ErrorResponse) => this.$refs.deleteForm.handleErrors(e));
    }
  }

  @Watch('transportCost', { immediate: true, deep: true })
  handleTransportCostChanged(val: TransportCost) {
    if (!val) {
      return undefined;
    }

    // @ts-ignore
    this.payload = structuredClone(val);
  }

  @Watch('workspace')
  workspaceChanged(val: Workspace) {
    this.$router.push({ name: 'transport-costs' });
  }
}
